import { render, staticRenderFns } from "./verify-your-identity.vue?vue&type=template&id=a3270c7e&scoped=true"
import script from "./verify-your-identity.vue?vue&type=script&lang=js"
export * from "./verify-your-identity.vue?vue&type=script&lang=js"
import style0 from "./verify-your-identity.vue?vue&type=style&index=0&id=a3270c7e&prod&scoped=true&lang=css"
import style1 from "./verify-your-identity.vue?vue&type=style&index=1&id=a3270c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3270c7e",
  null
  
)

export default component.exports